module.exports = __webpack_public_path__ + "fonts/1b3312c.woff";